// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__4Tfoa {
    display: flex;
    flex-direction: column;
    margin: var(--container-margin) auto 0;
    width: calc(950px + var(--container-padding) * 2);
    padding: 0 var(--container-padding);
    max-width: 100%;
}

.styles_container__4Tfoa h1 {
    color: var(--primary-color);
    margin-bottom: 0;
}

.styles_container__4Tfoa h5 {
    margin: 26px 0 0 0;
    line-height: 21px;
}

.styles_container__4Tfoa p {
    margin: 0;
    line-height: 21px;
}

.styles_agreement__qNn7\\+ {
    width: 100%;
    border: 1px solid #707070;
    background-color: white;
    padding: 18px 52px;
    margin: 35px 0 25px 0;
}

.styles_submit__J262n {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 133px;
    align-items: center;
}

.styles_form__MdsMF {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    width: 100%;
    grid-gap: 50px;
}

.styles_btns__baBLQ {
    display: flex;
    flex-direction: column;
    width: 200px;
    grid-gap: 25px;
}

.styles_formInner__rDEuf {
    display: flex;
    max-width: 100%;
    flex: 1 1;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Disclaimer/styles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,sCAAsC;IACtC,iDAAiD;IACjD,mCAAmC;IACnC,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;;IAEf,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAO;AACX","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    margin: var(--container-margin) auto 0;\n    width: calc(950px + var(--container-padding) * 2);\n    padding: 0 var(--container-padding);\n    max-width: 100%;\n}\n\n.container h1 {\n    color: var(--primary-color);\n    margin-bottom: 0;\n}\n\n.container h5 {\n    margin: 26px 0 0 0;\n    line-height: 21px;\n}\n\n.container p {\n    margin: 0;\n    line-height: 21px;\n}\n\n.agreement {\n    width: 100%;\n    border: 1px solid #707070;\n    background-color: white;\n    padding: 18px 52px;\n    margin: 35px 0 25px 0;\n}\n\n.submit {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    margin-bottom: 133px;\n    align-items: center;\n}\n\n.form {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n\n    width: 100%;\n    grid-gap: 50px;\n}\n\n.btns {\n    display: flex;\n    flex-direction: column;\n    width: 200px;\n    grid-gap: 25px;\n}\n\n.formInner {\n    display: flex;\n    max-width: 100%;\n    flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__4Tfoa`,
	"agreement": `styles_agreement__qNn7+`,
	"submit": `styles_submit__J262n`,
	"form": `styles_form__MdsMF`,
	"btns": `styles_btns__baBLQ`,
	"formInner": `styles_formInner__rDEuf`
};
export default ___CSS_LOADER_EXPORT___;
